<template>
  <el-dialog
        title="命中渠道"
        :visible.sync="dialogIsShow"
        width="1000px"
        :append-to-body="true"
        class="channel-search-dialog"
        :destroy-on-close="true"
        @open="openCallback"
        @close="closeCallback"
    >
        <div class="dialog-body">
            <el-form class="dialog-form" ref="formRef" :model="form" label-width="120px" :rules="formRule">
                <el-form-item label="命中渠道：" prop="channelId">
                    <el-select
                        style="width: 100%;"
                        v-model="form.channelId"
                        placeholder="请输入渠道名称进行搜索"
                        filterable
                        clearable
                        remote
                        :remote-method="remoteMethod"
                        :loading="isLoadingChannelOptions"
                    >
                        <el-option
                        v-for="item in channelOptions"
                        :key="item.id"
                        :label="`(${item.id}) ${item.name}`"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="版本号：" prop="apkVersion">
                    <el-input-number class="version-input" style="width: 100%;" v-model="form.apkVersion" :min="0" placeholder="输入应用版本，正整数" :controls="false"></el-input-number>
                </el-form-item>
                <el-form-item label="协议版本号：" prop="protocolVersion">
                    <el-radio-group v-model="form.protocolVersion">
                        <el-radio :label="1">老版本</el-radio>
                        <el-radio :label="2">新版本</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="设备UID：">
                    <el-input v-model="form.uid" placeholder="请输入设备UID"></el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" style="margin-bottom: 16px;" @click="handleQuery">发起查询</el-button>
            <el-input v-model="searchResult" type="textarea" :rows="10" :readonly="true"></el-input>
        </div>
    </el-dialog>
</template>

<script>
import { getChannels } from '@/api/runActivityManage/activity'
import { channelHit } from '@/api/tv/strategy'
export default {
  name: 'MyComponent',
  components: {},
  model: {
    prop: 'dialogIsShow',
    event: 'changeDialogIsShow'
  },
  props: {
    dialogIsShow: Boolean,
  },
  data() {
    return {
        form: {
            channelId: '',
            apkVersion: '',
            protocolVersion: 1,
            uid: '',
        },
        searchResult: '',
        channelOptions: [],
        isLoadingChannelOptions: false,
        isLoading: false,
        formRule: {
            channelId: [
                { required: true, message: '请选择渠道', trigger: 'change' }
            ],
            apkVersion: [
                { required: true, message: '请输入版本号', trigger: 'change' }
            ],
            protocolVersion: [
                { required: true, message: '请选择协议版本号', trigger: 'change' }
            ],
        },
    }
  },
  computed: {},
  watch: {},
  methods: {
    // 远程获取渠道选项
    async remoteMethod(query) {
        if (query !== '') {
            try{
                this.isLoadingChannelOptions = true
                const {data: {data}} = await getChannels({
                    limit: 99999,
                    page: 1,
                    name: query
                })
                this.channelOptions = data
            }finally{
                this.isLoadingChannelOptions = false
            }
        } else {
            this.channelOptions = [];
        }
    },
    // 发起查询
    async handleQuery() {
        this.$refs['formRef'].validate(async (valid) => {
            if (valid) {
                try{
                    this.isLoading = true
                    const {data: {data}} = await channelHit(this.form)
                    this.searchResult = JSON.stringify(data)
                }finally{
                    this.isLoading = false
                }
            }
        })
    },
    //重置表单
    resetForm() {
        this.form = {
            channelId: '',
            apkVersion: '',
            protocolVersion: 1,
            uid: '',
        }
        this.searchResult = ''
    },
    // 打开回调
    openCallback() {
        this.resetForm()
    },
    // 关闭回调
    closeCallback() {
        this.$emit('changeDialogIsShow', false)
    }
  },
  created() {},
  mounted() {}
}
</script>

<style>
.channel-search-dialog{
    display: flex;
    align-items: center;
    justify-content: center;
    .el-dialog{
        margin-top: unset !important;
        margin: unset !important;
    }
    .dialog-body{
        display: flex;
        flex-direction: column;
        align-items: center;
        .dialog-form{
            width: 50%;
            .version-input{
                .el-input__inner{
                    text-align: left;
                }
            }
        }
    }
}

</style>